import React, { Component } from 'react';
import { connect } from 'react-redux';
import getTransferByProductToken from 'state/checkoutPage/transfers/selectors/getTransferByProductToken';
import { getInsuranceByProductToken } from 'state/checkoutPage/insurances/selectors';
import { getSelectedEarthToday } from 'state/checkoutPage/additionalServices/selectors/getSelectedEarthToday';
import getCancellationProtectionByProductToken from 'state/checkoutPage/cancellationProtections/selectors/getCancellationProtectionByProductToken';
import getVehicleRentalsByProductTokens from 'state/checkoutPage/vehicleRental/selectors/getVehicleRentalsByProductTokens';
import OtherExtrasSummaryComponent from './OtherExtrasSummaryComponent';

class OtherExtrasSummary extends Component {
  constructor(props) {
    super(props);

    const { summaryType, exclusive } = props;
    this.summaryKey = { summaryType, exclusive };
  }

  render() {
    const {
      transfers,
      vehicleRentals,
      insurances,
      cancellationProtections,
      additionalServices,
      selectedOtherExtras = {},
      currency,
    } = this.props;

    if (selectedOtherExtras === null) {
      return null;
    }

    const {
      transfer,
      vehicleRentals: _vehicleRentals,
      insurance,
      cancellationProtection,
      co2Compensation,
      earthToday,
    } = selectedOtherExtras;
    const selectedTransfer = getTransferByProductToken(transfers, transfer);
    const selectedVehicleRentals = getVehicleRentalsByProductTokens(vehicleRentals, _vehicleRentals);
    const selectedInsurance = getInsuranceByProductToken(insurances, insurance);
    const selectedCancellationProtection = getCancellationProtectionByProductToken(
      cancellationProtections,
      cancellationProtection
    );
    const noSelectedVehicleRentals =
      !selectedVehicleRentals || (selectedVehicleRentals && selectedVehicleRentals.length === 0);

    const selectedEarthToday = getSelectedEarthToday(earthToday, additionalServices);

    if (
      !selectedTransfer &&
      !selectedInsurance &&
      !selectedCancellationProtection &&
      noSelectedVehicleRentals &&
      !co2Compensation &&
      !earthToday
    ) {
      return null;
    }

    return (
      <OtherExtrasSummaryComponent
        summaryKey={this.summaryKey}
        transfers={selectedTransfer}
        vehicleRentals={selectedVehicleRentals}
        insurances={selectedInsurance}
        co2compensation={co2Compensation}
        earthToday={selectedEarthToday}
        cancellationProtections={selectedCancellationProtection}
        currency={currency}
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    transfers: state.checkoutPageTransfers.transfers,
    vehicleRentals: state.checkoutPageVehicleRental.value && state.checkoutPageVehicleRental.value.carRentals,
    insurances: state.checkoutPageInsurances.insurances,
    cancellationProtections: state.checkoutPageCancellationProtections.cancellationProtections,
    additionalServices: state.checkoutPageAdditionalServices.additionalServices,
    selectedOtherExtras: state.checkoutPageTravelSummary.selectedOtherExtras, // Required for component update
    currency: state.settings.value.locale.currency,
  };
}

export default connect(mapStateToProps)(OtherExtrasSummary);
